import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useHasBulkEmailAccess, useHasBulkTextAccess } from '@frontend/feature-access';
import { useLocationIdsField } from '../../hooks/use-location-ids-field';
import { useSortDropdownField } from '../../hooks/use-sort-dropdown-field';
import { useYearDropdownField } from '../../hooks/use-year-dropdown-field';
import { CampaignListHeader } from '../campaign-list-header/campaign-list-header';
import { CampaignListBody } from './campaign-list-body/campaign-list-body';

type Props = { campaignType: CampaignType };

// TODO: Test to make sure feature flags and ACLs work as expected with multi-location and single location setups
// TODO: Implement search when the backend is ready
export const CampaignList = ({ campaignType }: Props) => {
  const { locationsWithBulkEmailAccess } = useHasBulkEmailAccess();
  const { locationsWithBulkTextAccess } = useHasBulkTextAccess();
  const accessibleLocations =
    campaignType === CampaignType.EMAIL ? locationsWithBulkEmailAccess : locationsWithBulkTextAccess;

  const { locationsFieldProps, selectedLocationIds } = useLocationIdsField(accessibleLocations);
  const { sortDropdownFieldProps, sortDirection: selectedSort } = useSortDropdownField();
  const { yearDropdownFieldProps, selectedYear } = useYearDropdownField();

  return (
    <>
      <CampaignListHeader
        accessibleLocations={accessibleLocations}
        campaignType={campaignType}
        locationsFieldProps={locationsFieldProps}
        sortDropdownFieldProps={sortDropdownFieldProps}
        yearDropdownFieldProps={yearDropdownFieldProps}
      />
      <CampaignListBody
        campaignType={campaignType}
        selectedLocationIds={selectedLocationIds}
        selectedSort={selectedSort}
        selectedYear={selectedYear}
      />
    </>
  );
};
